module.exports = __webpack_public_path__ + "img/redgps.de0dfa61.png";